export default __webpack_public_path__ + "static/media/eddy_de_pretto_lowdef.134222dc.png";